import Vue from 'vue';

export const IbanRules = [
	/**
	 * @param user general user object
	 * @param user_details detailed user object
	 * */

	function (user) {
		//User object available
		return user;
	},
	function (user) {
		//User status should be provisional == 0:
		return user.customerstatus_id === 0;
	},
	function (user) {
		//IBAN image should be still empty
		return user.bank_account_upload_status === false
	},
	function (user) {
		//Bank account should not be validated by Customer Support
		return user.bankaccountstatus === false
	},
	function (user, user_details, type) {
		//This rule applies only for iban_text field

		//Or If bank account not created
		if(type !== 'text' || !user_details){
			return true;
		}


		//If iban_text is empty, the user are able to edit field
		return  true;//user_details && user_details.bankaccount === '';
	}

];


export const mixins = {
	methods:{
		isSubmit(scope) {

			//Check if any field in scope was touched
			let touched = false;

			for (let key in this.fields['$' + scope]) {

				//Use vee-validate fields-flags object
				if (this.fields['$' + scope][key].touched) {
					touched = true;
				}
			}
			return touched;
		},

		processFile(event, model, destination) {
			Vue.set(model, destination, []);
			this.encodeImageFileAsURL(event, model, destination);
		},
		getFileIcon(src) {

			if (/^data:application\/pdf/g.test(src)) {
				return require('../img/ico/pdf-file.svg');
			} else {
				return src;
			}
		}
	}
}
